export { default } from './ProgramTooltipDetails';
